import React from 'react'
import { Outlet } from 'react-router-dom'

const index = () => {
  return (
    <div>
      <h4>Appointments</h4>
      <Outlet />
      </div>
  )
}

export default index